var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgGetFeature = function SvgGetFeature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 48c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32zm32-36c-19.882 0-36 16.118-36 36s16.118 36 36 36 36-16.118 36-36-16.118-36-36-36zm2.373 17.298a2 2 0 0 0-3.746 0l-4.286 11.43H31a2 2 0 0 0-1.414 3.413l8.745 8.745-2.908 11.629a2 2 0 0 0 3.097 2.117l9.98-7.072 9.98 7.072a2 2 0 0 0 3.097-2.117L58.67 52.886l8.744-8.745A2 2 0 0 0 66 40.727H54.659l-4.286-11.43zM45.6 43.429l2.9-7.733 2.9 7.733a2 2 0 0 0 1.873 1.298h7.899L55.04 50.86a2 2 0 0 0-.526 1.899l1.872 7.488-6.73-4.769a2 2 0 0 0-2.312 0l-6.73 4.769 1.872-7.488a2 2 0 0 0-.526-1.9l-6.132-6.13h7.9A2 2 0 0 0 45.6 43.43z"
  })));
};

export default SvgGetFeature;